// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ChevronsUpDown as RawChevronsUpDown } from "lucide-react";
export const ChevronsUpDown = /* @__PURE__ */ createIcon(RawChevronsUpDown, "ChevronsUpDown", 2);
